<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp1" id="pt1"> </p>
<p class="Part-Number-pn"><span epub:type="pagebreak" id="pg_27" title="27"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample"><span class="Colonna-MT">PART I</span></span></span></p>
<p class="Part-Title-pt"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample">BY THE WATERS OF BABYLON</span></p>
<p class="Part-Epigraph-verse-pepiv_pt"><span class="ePub-I">Like a picture it seemed of the primitive, pastoral ages,</span></p>
<p class="Part-Epigraph-verse-pepiv_pt"><span class="ePub-I">Fresh with the youth of the world, and recalling Rebecca and Isaac,</span></p>
<p class="Part-Epigraph-verse-pepiv_pt"><span class="ePub-I">Old and yet ever new, and simple and beautiful always,</span></p>
<p class="Part-Epigraph-verse-pepiv_pt"><span class="ePub-I">Love immortal and young in the endless succession of lovers.</span></p>
<p class="Part-Epigraph-Source-peps">—Henry Wadsworth Longfellow</p>
<p class="Part-Epigraph-verse-pepiv_pt"><span class="ePub-I">Joyance is come, dispelling cark and care;</span></p>
<p class="Part-Epigraph-verse-pepiv_pt"><span class="ePub-I">We are united, enviers may despair …</span></p>
<p class="Part-Epigraph-verse-pepiv_pt"><span class="ePub-I">One hour of joyance made us both forget</span></p>
<p class="Part-Epigraph-verse-pepiv_pt"><span class="ePub-I">What from excess of terror grey’d our hair.</span></p>
<p class="Part-Epigraph-Source-peps">—from Richard Burton’s translation of <span class="ePub-I">One Thousand and One Nights</span></p>
<p class="Part-Epigraph-verse-pepiv_pt"><span class="ePub-I">cras amet qui numquam amavit</span></p>
<p class="Part-Epigraph-verse-pepiv_pt"><span class="ePub-I">quique amavit cras amet</span></p>
<p class="Part-Epigraph-Source-peps">—“The Vigil of Venus”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?3dd276da